import { Badge, BadgeProps } from '@mui/material';

export function BaseBadge({ ...otherProps }: BadgeProps) {
  return <Badge {...otherProps} />;
}
